// extracted by mini-css-extract-plugin
export default {"wrapper":"Contracts_wrapper__j4XnM","title":"Contracts_title__zOtxq","list":"Contracts_list__6J8vU"};